import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

interface MyHrUsersImportCollapseLabelProps {
  label: React.ReactNode;
  expanded: boolean;
  handleExpandClick: () => void;
}

export const MyHrUsersImportCollapseLabel = ({
  label,
  expanded,
  handleExpandClick,
}: MyHrUsersImportCollapseLabelProps) => {
  return (
    <Box
      id="my-hr-admin-users-import-title"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      padding="0px 16px"
    >
      <Box
        style={{
          fontSize: 20,
          padding: "10px 16px",
          color: "#5e6366",
        }}
        display="flex"
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Box marginRight="26px">{label}</Box>
      </Box>
      <Box>
        <IconButton
          id="my-hr-users-import-iconbutton"
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
          style={
            expanded
              ? { padding: 0, transform: "rotate(180deg)" }
              : { padding: 0 }
          }
        >
          <ExpandMore />
        </IconButton>
      </Box>
    </Box>
  );
};

export default MyHrUsersImportCollapseLabel;
